// extracted by mini-css-extract-plugin
export default {"header":"clb69dHe5UMLr9VPMbqH","systemName":"g4LWj7RJ14TJOGy6gxld","headerRight":"l5o2XRqTPwfbkhzoCpqH"};